import { Button, TagSelect } from '@baseball-near-you/ui';
import { useTags } from '@bb/lib/hooks/useTags';
import { ReviewStep, useReviewContext } from './AddReviewModal';

export const AddTagsStep = () => {
  const { tags, tagsLoading } = useTags();
  const { selectedTags, setSelectedTags, setStep } = useReviewContext();

  return (
    <div className="space-y-5 rounded-md bg-white pt-4 text-left">
      <TagSelect
        tags={tags}
        tagsLoading={tagsLoading}
        selectedTags={selectedTags}
        onTagSelect={(tag) => {
          if (selectedTags?.includes(tag.id)) {
            // remove it
            setSelectedTags(selectedTags?.filter((tagId) => tagId !== tag.id));
          } else {
            setSelectedTags([...(selectedTags ?? []), tag.id]);
          }
        }}
      />
      <Button
        type="button"
        className="w-full"
        onClick={() => setStep(ReviewStep.Message)}
      >
        Continue
      </Button>
    </div>
  );
};
